import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Select from "react-select";
import Toastify from "../../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../../helpers/common";

function EditProduct() {
  const [units, setUnits] = useState([]);
  const [agents, setAgents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [productCodeErr, setProductCodeErr] = useState("");

  const [productName, setProductName] = useState("");
  const [productNameErr, setProductNameErr] = useState("");

  const [current, setCurrent] = useState();
  const [currentErr, setCurrentErr] = useState();
  const [GST, setGST] = useState();
  const [category, setCategory] = useState([]);
  const [categoryErr, setCategoryErr] = useState("");
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const defaultValues = {
    DefClass: "",
    DefSize: "",
    DefAgentID: "",
    DefUnitID: "",
    Wgt: "",
    Cost: "",
    SellA: "",
    SellB: "",
    SellC: "",
    SellD: "",
    SellE: "",
    SellF: "",
    RRP: "",
    ExW: "",
  }
  const [productDetails, setProductDetails] = useState([]);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  const { user } = useAuth();
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      let commanURL =
        process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
      let commonResponse = await GETREQUEST(commanURL, user.jwtToken);
      if (commonResponse?.data) {
        setUnits(commonResponse.data.units);
        setAgents(commonResponse.data.agent);
        let list = [];
        commonResponse.data.categories.forEach((res) => {
          list = [
            ...list,
            {
              value: res.CategoryID,
              label: res.CategoryName,
            },
          ];
        });
        setCategories(list);
      }

      let URL = process.env.REACT_APP_API_URL + "/get-product/" + id;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        const {
          ProductCode,
          ProductName,
          Current,
          GST,
          tblProductDetails,
          tblProductCategoryMaps,
        } = response.data;
        let list = [];
        tblProductCategoryMaps.forEach((el) => {
          return (list = [
            ...list,
            {
              value: el.CategoryID,
              label: el.tblCategory.CategoryName,
            },
          ]);
        });
        setCategory(list);
        setProductCode(ProductCode);
        setProductName(ProductName);
        setCurrent(String(Current));
        setProductDetails(tblProductDetails);
        setGST(GST);
      }
    }
    fetchData();
  }, []);
  let navigate = useNavigate();
  const editProduct = async (e) => {
    e.preventDefault();
    let cIds = [];
    category.forEach((cat) => {
      cIds.push(cat.value);
    });
    if (
      productCode == "" &&
      productName == "" &&
      category.length <= 0 &&
      current == ""
    ) {
      setProductCodeErr(true);
      setProductNameErr(true);
      setCategoryErr(true);
      setCurrentErr(true);
      return false;
    }
    let URL = process.env.REACT_APP_API_URL + "/update-product";
    if (productCode && productName && category.length > 0) {
      let payload = {
        ProductCode: productCode,
        ProductName: productName,
        CategoryIDs: cIds,
        Current: parseInt(current),
        GST,
        ProductID: id,
        ProductDetails: productDetails,
      };
      setMessage('');
      setMessageType('');
      let response = await POSTREQUEST(URL, payload, user.jwtToken);
      if (response?.data) {
        if (response.data.success) {
          setMessage(response.data.message);
          setMessageType('success');
          setTimeout(() => {
            navigate("/products");
          }, 2000);
        } else {
          setMessage(response.data.message);
          setMessageType('error');
        }
      } else {
        setMessage(response?.error?.message || 'Failed to update Product !!');
        setMessageType('error');
      }
    } else if (productCode == "") {
      setProductCodeErr(true);
      return false;
    } else if (productName == "") {
      setProductNameErr(true);
      return false;
    } else if (category.length <= 0) {
      setCategoryErr(true);
      return false;
    }
  };

  const renderCrudDiv = (copyIndex = '') => {
    let copyIndexData = ''
    if (copyIndex !== '') {
      copyIndexData = productDetails.find((data, index) => index == copyIndex);
    }
    setProductDetails([
      ...productDetails,
      copyIndexData || defaultValues]);
  };


  const handleDelete = (index) => {
    let productD = productDetails.filter((a, i) => index !== i);
    setProductDetails(productD);
  };
  const handleChange = (index, event, isTrailingZero = false) => {
      const { name, value } = event.target;
      let updatedValue = isTrailingZero ? addTrailingZeros(value) : formatPrice(value)
      let productD = [...productDetails];
      productD[index] = { ...productDetails[index], [name]: updatedValue};
      setProductDetails(productD);
    };

  const handleTextChange = (index, event) => {
    const { name, value } = event.target;
    let productD = [...productDetails];
    productD[index] = { ...productDetails[index], [name]: value };
    setProductDetails(productD);
  };


  const renderProductDetailBlock = (el, i) => {
    return (
      <React.Fragment key={i}>
        <div className="spacer-2"></div>
        <div className="card p-4">
          <div className="card-header bg-white border-bottom-0">
            <h1 className="title-semibold fs-24 mb-1">Product Detail</h1>
            {productDetails?.length > 1 && (
              <div
                style={{
                  position: "absolute",
                  right: "80px",
                  top: "20px",
                  padding: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleDelete(i)}
              >
                <i className="icon icon-delete fs-20"></i>
              </div>
            )}
            <div style={{
              position: "absolute",
              right: 0,
              top: "15px",
              padding: "10px",
              cursor: "pointer",
            }}>
              <button type="button" className="btn btn-outline-success" onClick={() => renderCrudDiv(i)}>
                Clone
              </button>
            </div>
          </div>
          <div className="mt-3">
            <div className="d-flex">
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Default Unit
                </label>
                <div className="col">
                  <select
                    required
                    name="DefUnitID"
                    className="form-select input-md"
                    aria-label="Default select example"
                    onChange={(e) => handleTextChange(i, e)}
                    value={el.DefUnitID}
                  >
                    <option value="">Select Units</option>
                    {units.map((unit, index) => {
                      return (
                        <option value={unit.UnitID} key={index}>
                          {unit.UnitName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Default Class
                </label>
                <div className="col">
                  <input
                    name="DefClass"
                    type="text"
                    className="form-control input-md"
                    placeholder="Default Class"
                    onChange={(e) => handleTextChange(i, e)}
                    value={el.DefClass}
                  />
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Default Size
                </label>
                <div className="col">
                  <input
                    name="DefSize"
                    type="text"
                    className="form-control input-md"
                    placeholder="Default Size"
                    onChange={(e) => handleTextChange(i, e)}
                    value={el.DefSize}
                  />
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Default Agent
                </label>
                <div className="col">
                  <select
                    required
                    name="DefAgentID"
                    className="form-select input-md"
                    aria-label="Default select example"
                    onChange={(e) => handleTextChange(i, e)}
                    value={el.DefAgentID}
                  >
                    <option value="">Select Agent</option>
                    {agents.map((agent, index) => {
                      return (
                        <option value={agent.AgentID} key={index}>
                          {agent.AgentCode}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Cost
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      required
                      name="Cost"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.Cost}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Wgt
                </label>
                <div className="col">
                  <input
                    required
                    name="Wgt"
                    type="number"
                    className="form-control input-md"
                    placeholder="Wgt"
                    onChange={(e) => handleChange(i, e)}
                    onBlur={(e) => handleChange(i, e, true)}
                    value={el.Wgt}
                  />
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  ExW
                </label>
                <div className="col">
                  <input
                    required
                    name="ExW"
                    type="number"
                    className="form-control input-md"
                    placeholder="ExW"
                    onChange={(e) => handleChange(i, e)}
                    onBlur={(e) => handleChange(i, e, true)}
                    value={el.ExW}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell A
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      required
                      name="SellA"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.SellA}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell A WS_GP%
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="Sell A WS_GP%"
                    value={
                      el.Cost && el.SellA
                        ? `${parseFloat(
                          ((el.SellA - el.Cost) / el.SellA) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell E
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      name="SellE"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.SellE}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>

              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell E WS_GP%
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="Sell E WS_GP%"
                    value={
                      el.Cost && el.SellE
                        ? `${parseFloat(
                          ((el.SellE - el.Cost) / el.SellE) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell B
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      name="SellB"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.SellB}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell B WS_GP%
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="Sell B WS_GP%"
                    value={
                      el.Cost && el.SellB
                        ? `${parseFloat(
                          ((el.SellB - el.Cost) / el.SellB) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell F
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      name="SellF"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.SellF}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>

              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell F WS_GP%
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="Sell F WS_GP%"
                    value={
                      el.Cost && el.SellF
                        ? `${parseFloat(
                          ((el.SellF - el.Cost) / el.SellF) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell C
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      name="SellC"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.SellC}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell C WS_GP%
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="Sell C WS_GP%"
                    value={
                      el.Cost && el.SellC
                        ? `${parseFloat(
                          ((el.SellC - el.Cost) / el.SellC) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  RRP
                </label>
                <div className="col">
                  <input
                    required
                    name="RRP"
                    type="number"
                    className="form-control input-md"
                    placeholder="RRP"
                    onChange={(e) => handleChange(i, e)}
                    onBlur={(e) => handleChange(i, e, true)}
                    value={el.RRP}
                  />
                </div>
              </div>

              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  RTL_GP
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="RTL_GP"
                    value={
                      el.RRP && el.SellB
                        ? `${parseFloat(
                          ((el.RRP - el.SellB) / el.RRP) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell D
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      name="SellD"
                      type="number"
                      className="form-control input-md text-end ps-4"
                      onChange={(e) => handleChange(i, e)}
                      onBlur={(e) => handleChange(i, e, true)}
                      value={el.SellD}
                    />
                    <span className="text-lite cps-4">$</span>
                  </div>
                </div>
              </div>
              <div className="width-xl-25 width-lg-80 cmb-15 row g-1">
                <label className="width-sm-40 d-flex align-items-center fs-15 text-dark text-nowrap">
                  Sell D WS_GP%
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-md"
                    placeholder="Sell D WS_GP%"
                    value={
                      el.Cost && el.SellD
                        ? `${parseFloat(
                          ((el.SellD - el.Cost) / el.SellD) * 100
                        ).toFixed(2)}%`
                        : 0
                    }
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment >
    );
  };
  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/products"
                    className="text-decoration-none text-primary"
                  >
                    Products
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Edit Product
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-80 width-xl-80 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Edit Product</h1>
                  {/* <p className="text-lite fs-15 mb-0">
                    Please enter details to add new product
                  </p> */}
                </div>
                <form onSubmit={editProduct}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Product Code
                      </label>
                      <div className="col">
                        <input
                          required
                          type="text"
                          className={
                            "form-control input-md" +
                            (productCodeErr ? " is-invalid" : "")
                          }
                          placeholder="Product Code"
                          onChange={(e) => {
                            setProductCodeErr(false);
                            setProductCode(e.target.value);
                          }}
                          defaultValue={productCode}
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Product Name
                      </label>
                      <div className="col">
                        <input
                          required
                          type="text"
                          className={
                            "form-control input-md" +
                            (productNameErr ? " is-invalid" : "")
                          }
                          placeholder="Product Name"
                          onChange={(e) => {
                            setProductNameErr(false);
                            setProductName(e.target.value);
                          }}
                          defaultValue={productName}
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Catagory
                      </label>
                      <div className="col">
                        <Select
                          required
                          isMulti
                          name="category"
                          options={categories}
                          className={categoryErr ? " is-invalid " : ""}
                          placeholder="Select Catagory"
                          onChange={(value) => {
                            setCategoryErr(false);
                            setCategory(value);
                          }}
                          value={category}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label
                        htmlFor="remember"
                        className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap"
                      >
                        GST
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setGST(1);
                            } else {
                              setGST(0);
                            }
                          }}
                          checked={GST == 1 ? true : false}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md " +
                            (currentErr ? "is-invalid" : "")
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrentErr(false);
                            setCurrent(e.target.value);
                          }}
                          value={current}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {productDetails.map((el, i) => {
                    return renderProductDetailBlock(el, i);
                  })}
                  <div className="spacer-2"></div>
                  <button
                    className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                    onClick={renderCrudDiv}
                    type="button"
                  >
                    <i className="icon icon-add cpe-5 fs-13"></i> Add Product
                    Detail
                  </button>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Save - Update Product
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default EditProduct;
